import script from "./Link.vue?vue&type=script&lang=ts"
export * from "./Link.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__